const palette = {
  primary: {
    main: '#3d3a3b',
    light: '#676465',
    dark: '#171415',
  },
  secondary: {
    main: '#506c24',
    light: '#7e9a4f',
    dark: '#254100',
  },
  text: {
    primary: '#6d6c6d',
    secondary: '#c5c4c5',
  },
}

export default palette
